<template>
  <div>
    <div class="p-relative header-image pb-5">
      <div
        class="w-100 text-center white--text font-weight-bold header-text py-4 px-3"
      >
        Welcome<span v-if="user">, {{ user.full_name }}</span
        >. Quickly search for any cards or passes.
      </div>

      <search-bar @searchedFile="fileSearch" />
    </div>

    <b-container v-show="searchedFile" class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col
                sm="12"
                md="6"
                lg="6"
                class="p-relative my-2 mb-5 my-md-0 mb-md-0 d-flex align-items-end"
              >
                <h4 class="font-weight-bold">All Search Results</h4>
              </b-col>
              <b-col
                sm="12"
                md="6"
                lg="6"
                class="p-relative d-flex justify-content-center justify-content-md-end align-items-end"
              >
                <!-- <b-button
                  @click="bulkDownload()"
                  variant="outlined"
                  class="float-sm-right font-weight-bold gray--2"
                >
                  <b-icon icon="download"></b-icon> Download
                </b-button> -->
                <b-button-group
                  v-show="checkedFiles.length"
                  variant="outlined"
                  class="float-sm-right font-weight-bold gray--2"
                  :disabled="loading"
                >
                  <b-dropdown
                    :text="`Selected ${checkedFiles.length} item/s`"
                    variant="outlined"
                    class="gray--2"
                  >
                    <b-dropdown-item @click="bulkDownload">
                      <b-icon
                        icon="download"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Download Selected Item/s
                    </b-dropdown-item>
                    <!-- <b-dropdown-item @click="shareFiles">
                      <b-icon
                        icon="cursor"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Share Selected File/s
                    </b-dropdown-item> -->
                  </b-dropdown>
                  <b-button
                    right
                    variant="outlined"
                    class="gray--2"
                    @click="clearSelectedFiles"
                  >
                    Clear
                  </b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </b-container>
          <b-card border-variant="light" bg-variant="light" body-class="px-0">
            <file-list
              :files="files"
              ref="searchedFileList"
              @selectedFiles="filesSelected"
              @shareSingleFile="shareFiles"
            />

            <p v-if="searchedFile && !files.length" class="mb-0 px-3">
              No File/s found.
            </p>
            <b-pagination
              v-if="filesMeta.total > searchPerPage"
              v-model="searchCurrentPage"
              :total-rows="filesMeta.total"
              :per-page="searchPerPage"
              class="px-3 pt-4"
              align="right"
            ></b-pagination>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <!-- <div fluid-grow alt="banner" class="header-image rounded-0"></div> -->

    <b-container
      v-show="!searchedFile"
      v-if="homeData.data"
      class="custom-container mt-4 mt-sm-5"
    >
      <b-row v-if="isPlainTradie">
        <b-col cols="12" class="px-3">
          <clock-in-out-card class="mt-4" />
        </b-col>
      </b-row>

      <b-row v-if="isTradieUser">
        <b-col cols="12" class="px-3">
          <weekly-timesheet-card class="mt-3" />
        </b-col>
      </b-row>

      <b-row v-if="isTradieUser">
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12">
                <b-button
                  v-b-toggle.company-associations
                  variant="link"
                  class="px-0 text-dark text-decoration-none text-left"
                >
                  <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                    Your Company Associations
                    <span class="when-open">
                      <b-icon icon="caret-up-fill" scale="0.5"></b-icon>
                    </span>
                    <span class="when-closed">
                      <b-icon icon="caret-down-fill" scale="0.5"></b-icon>
                    </span>
                  </h4>
                </b-button>
              </b-col>
            </b-row>
          </b-container>
          <b-collapse :visible="true" id="company-associations" class="mt-2">
            <b-card border-variant="light" bg-variant="light" body-class="px-0">
              <company-associations-list />
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>

      <b-row v-else>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12" sm="6">
                <b-button
                  v-b-toggle.recent-requested
                  variant="link"
                  class="px-0 text-dark text-decoration-none text-left"
                >
                  <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                    Recently Requests You Created
                    <span class="when-open">
                      <b-icon icon="caret-up-fill" scale="0.5"></b-icon>
                    </span>
                    <span class="when-closed">
                      <b-icon icon="caret-down-fill" scale="0.5"></b-icon>
                    </span>
                  </h4>
                </b-button>
              </b-col>
              <b-col cols="12" sm="6">
                <a
                  type="button"
                  @click="
                    $router.push({
                      name: 'requests.list-page',
                    })
                  "
                  class="d-inline-block pt-0 pb-2 py-sm-4 pl-sm-2 ml-sm-auto float-sm-right text-decoration-underline text-primary"
                >
                  See all requests
                </a>
              </b-col>
            </b-row>
          </b-container>
          <b-collapse :visible="true" id="recent-requested" class="mt-2">
            <b-card border-variant="light" bg-variant="light" body-class="pa-1">
              <recent-request-file-list />
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12" sm="6">
                <b-button
                  v-b-toggle.file-shared
                  variant="link"
                  class="px-0 text-dark text-decoration-none text-left"
                >
                  <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                    {{
                      !isEmptyObj(user) && user.user_type === 'business_admin'
                        ? 'Files Shared With You'
                        : 'Recently Uploaded Files'
                    }}
                    <span class="when-open">
                      <b-icon icon="caret-up-fill" scale="0.5"></b-icon>
                    </span>
                    <span class="when-closed">
                      <b-icon icon="caret-down-fill" scale="0.5"></b-icon>
                    </span>
                  </h4>
                </b-button>
              </b-col>
              <b-col cols="12" sm="6">
                <a
                  type="button"
                  @click="
                    $router.push({
                      name: 'file.list-page',
                      params: { tab: 'shared' },
                    })
                  "
                  class="d-inline-block pt-0 pb-2 py-sm-4 pl-sm-2 ml-sm-auto float-sm-right text-decoration-underline text-primary"
                >
                  See all files
                </a>
              </b-col>
            </b-row>
          </b-container>
          <b-collapse :visible="true" id="file-shared">
            <b-card border-variant="light" bg-variant="light" body-class="px-0">
              <div
                v-if="!isEmptyObj(user) && user.user_type === 'business_admin'"
              >
                <file-list
                  v-if="
                    homeData.data.recent_shares ||
                    !isEmptyObj(homeData.data.recent_shares)
                  "
                  :files="homeData.data.recent_shares"
                />
                <div v-else class="text-center">
                  <!-- v-if="!homeData.data.recent_shares.length" -->
                  Empty file/s data
                </div>
              </div>
              <div v-else>
                <file-list
                  v-if="
                    homeData.data.recent_files ||
                    !isEmptyObj(homeData.data.recent_files)
                  "
                  :files="homeData.data.recent_files"
                />
                <div v-else class="text-center">
                  <!-- v-if="!homeData.data.recent_files.length" -->
                  Empty file/s data
                </div>
                <!-- <file-list v-else :files="homeData.data.recent_files" /> -->
              </div>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12" sm="6">
                <b-button
                  v-b-toggle.expiring-soon
                  variant="link"
                  class="px-0 text-dark text-decoration-none text-left"
                >
                  <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                    Expiring Soon
                    <span class="when-open">
                      <b-icon icon="caret-up-fill" scale="0.5"></b-icon>
                    </span>
                    <span class="when-closed">
                      <b-icon icon="caret-down-fill" scale="0.5"></b-icon>
                    </span>
                  </h4>
                </b-button>
              </b-col>
              <b-col cols="12" sm="6">
                <a
                  type="button"
                  @click="
                    $router.push({
                      name: 'file.list-page',
                    })
                  "
                  class="d-inline-block pt-0 pb-2 py-sm-4 pl-sm-2 ml-sm-auto float-sm-right text-decoration-underline text-primary"
                >
                  See all files
                </a>
              </b-col>
            </b-row>
          </b-container>
          <b-collapse :visible="true" id="expiring-soon">
            <b-card border-variant="light" bg-variant="light" body-class="px-0">
              <div
                v-if="!homeData.data.expiring_soon.length"
                class="text-center"
              >
                Empty file/s data
              </div>
              <file-list v-else :files="homeData.data.expiring_soon" />
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
    </b-container>

    <share-file-modal
      :showShareFiles="showShareFiles"
      :selectedFiles="checkedFiles"
      :fileShares="fileShares"
      @closeShareFileModal="showShareFiles = false"
      @fileShareResponsePrompt="shareFileResponsePrompt"
      @reloadFileList="getFileList"
    />

    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      :class="{
        'bg-danger border-danger': alertType === 'danger',
      }"
      dismissible
      fade
      :variant="alertType"
      @dismiss-count-down="countDownChanged"
    >
      {{ alertMsg }}
    </b-alert>
  </div>
</template>

<script>
import { zipDownloadName } from '@/utils/zipDownloadName'
import { mapGetters, mapActions } from 'vuex'
import { isEmpty } from 'lodash'
import SearchBar from '@/components/SearchBar'
import FileList from '@/components/lists/FileList'
// import HomePageRequestFileList from '@/components/lists/HomePageRequestFileList'
import RecentRequestFileList from '@/components/lists/RecentRequestFileList'
import CompanyAssociationsList from '@/components/lists/CompanyAssociationsList'
import ShareFileModal from '@/components/modals/ShareFileModal'
import ClockInOutCard from '@/components/timesheets/self/ClockInOutCard'
import WeeklyTimesheetCard from '@/components/timesheets/weekly/WeeklyTimesheetCard'

export default {
  components: {
    SearchBar,
    FileList,
    // HomePageRequestFileList,
    RecentRequestFileList,
    CompanyAssociationsList,
    ShareFileModal,
    ClockInOutCard,
    WeeklyTimesheetCard,
  },

  data() {
    return {
      loading: false,
      checkedFiles: [],
      searchedFile: '',
      showShareFiles: false,
      fileShares: [],
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary',
      searchCurrentPage: 1,
      suppressSearchPageWatch: false,
    }
  },

  computed: {
    // ...mapState({
    //   user: state => state.auth.user
    // }),
    ...mapGetters('auth', ['user', 'isSupervisorTradie']),
    ...mapGetters('file', ['files', 'filesMeta']),
    ...mapGetters('home', ['homeData']),

    searchPerPage() {
      const p = this.filesMeta && this.filesMeta.per_page
      return typeof p === 'number' && p > 0 ? p : 10
    },

    isTradieUser() {
      return (
        !this.isEmptyObj(this.user || {}) &&
        this.user &&
        this.user.user_type === 'tradie'
      )
    },

    // Plain tradies only — a supervisor-tradie already has self clock-in/out
    // via their crew view under /timesheets, so this card would be redundant
    // (and confusing) there.
    isPlainTradie() {
      return this.isTradieUser && !this.isSupervisorTradie
    },
  },
  methods: {
    ...mapActions({
      getFiles: 'file/getFiles',
      getHomeData: 'home/getHomeData',
      getSearchedFiles: 'file/getSearchedFiles',
    }),
    async getFileList() {
      this.loading = true
      try {
        await this.getFiles()
      } catch (e) {
        this.$bvToast.toast('Could not load files. Please try again.', {
          variant: 'danger',
          title: 'Error',
        })
      } finally {
        this.loading = false
      }
    },
    async getHomePageData() {
      this.loading = true
      try {
        await this.getHomeData()
      } catch (e) {
        this.$bvToast.toast(
          'Could not load your dashboard. Please try again.',
          {
            variant: 'danger',
            title: 'Error',
          },
        )
      } finally {
        this.loading = false
      }
    },
    filesSelected(files) {
      this.checkedFiles = files
    },
    clearSelectedFiles() {
      this.checkedFiles = []
      if (this.$refs.searchedFileList) {
        this.$refs.searchedFileList.clearFilesSelected()
      }
    },
    async bulkDownload() {
      await this.$api
        .get('download-bulk-files', {
          responseType: 'blob',
          params: { files: this.checkedFiles },
        })
        .then((data) => {
          const name = this.user.full_name
          const filename = zipDownloadName(name)
          const url = URL.createObjectURL(
            new Blob([data.data], {
              type: 'application/zip',
            }),
          )
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
        .catch((e) => {
          setTimeout((e) => {
            this.$emit('showAlert', 'downloaded unsuccessfully.')
          }, 5000)
        })
    },
    async fetchSearchResults(page) {
      this.loading = true
      try {
        await this.getSearchedFiles({
          search: this.searchedFile,
          page: page,
          limit: this.searchPerPage,
        })
      } catch (error) {
        this.$emit('showAlert', 'error while searching for file/s: ', error)
      } finally {
        this.loading = false
      }
    },

    async fileSearch(name) {
      this.searchedFile = name
      this.clearSelectedFiles()

      if (!this.searchedFile) {
        this.searchCurrentPage = 1
        await this.getFileList()
      } else {
        this.suppressSearchPageWatch = true
        this.searchCurrentPage = 1
        try {
          await this.fetchSearchResults(1)
        } finally {
          this.suppressSearchPageWatch = false
        }
      }
    },
    shareFiles() {
      let fileShared = find(this.files, { id: this.checkedFiles[0] })
      this.fileShares = fileShared.file_shares
      this.showShareFiles = true
    },
    async shareFileResponsePrompt(res) {
      if (res.success) {
        await this.getFileList()

        this.alertMsg =
          'File shared successfully to selected Business Admin emails: ' +
          res.data.success.join(', ')

        this.dismissCountDown = 15

        return
      } else {
        this.alertType = 'danger'

        if (res.status === 402 || res.status === 422) {
          if (res.message) {
            this.alertMsg = res.message
          } else {
            this.alertMsg = 'File shared unsuccessful!'
          }
        } else {
          this.alertMsg =
            'Something went wrong while submitting the share file email!'
        }
      }

      this.dismissCountDown = 5
    },
    showAlert() {
      this.dismissCountDown = 5
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    },
    isEmptyObj(obj) {
      return isEmpty(obj)
    },
  },
  watch: {
    async user() {
      await this.getHomePageData()
    },
    searchCurrentPage(page) {
      if (!this.searchedFile) {
        return
      }
      if (this.suppressSearchPageWatch) {
        this.suppressSearchPageWatch = false
        return
      }
      this.clearSelectedFiles()
      this.fetchSearchResults(page)
    },
  },
  // mounted() {
  //   this.getFileList()
  // }
}
</script>

<style lang="scss" scoped>
.header-image {
  // top: 88px;
  // height: 280px;
  background: transparent linear-gradient(130deg, #006cff 0%, #00429d 100%) 0%
    0% no-repeat padding-box;
}

.header-text {
  // top: 136px;
  // Clears the fixed top navbar (~88px on desktop, ~64-70px on mobile),
  // which the blue header block sits behind.
  margin-top: 88px;
  font-size: 35px;

  @media (max-width: 767px) {
    margin-top: 76px;
    font-size: 26px;
  }

  @media (max-width: 575px) {
    margin-top: 72px;
    font-size: 20px;
  }
}

/deep/ nav.center-screen {
  margin-top: 0;
}

/deep/ .collapsed {
  .when-open {
    display: none;
  }
}

/deep/ .not-collapsed {
  .when-closed {
    display: none;
  }
}

@media (max-width: 575px) {
  h4 {
    font-size: 1.15rem;

    &.font-weight-bold.pt-4 {
      padding-top: 0.75rem !important;
      margin-bottom: 0.25rem !important;
    }
  }

  // A global rule (_animations.scss) gives every .col-12 a 30px bottom
  // margin; when the title and its "See all" link stack into separate
  // columns on phones that means 30px after each. Collapse it for the
  // inner columns of this page's section headers only.
  /deep/ .container-fluid .col-12 {
    margin-bottom: 0.25rem;
  }

  // The global .btn rule fixes buttons at 56px tall; on phones that adds
  // dead space below the section titles, so let these size to content.
  /deep/ .btn.text-left {
    height: auto;
    padding-top: 0;
    padding-bottom: 0;
  }

  // The collapse toggles keep a small gap to their cards on phones.
  .collapse.mt-2,
  .collapsing.mt-2 {
    margin-top: 0.25rem !important;
  }

  // The section cards blend into the page background, so their default
  // 1.25rem body padding reads as an empty gap below the title row.
  /deep/ .card .card-body {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
}
</style>
